import {
  WIcon,
  wiconVector,
  wiconAlertCircle,
  wiconAlertTriangle,
  wiconAnnouncement02,
  wiconApproveBell,
  wiconApprovePath,
  wiconApprovePathRemove,
  wiconApprovePathSetting,
  wiconApprovePathStepBack,
  wiconArrowLeft,
  wiconArrowNarrowDown,
  wiconArrowNarrowDownRight,
  wiconArrowNarrowLeft,
  wiconArrowNarrowRight,
  wiconArrowNarrowUp,
  wiconArrowNarrowUpRight,
  wiconAtSign,
  wiconAttachment02,
  wiconBank,
  wiconBarChart10,
  wiconBell01,
  wiconBookClosed,
  wiconBookOpen01,
  wiconBookmark,
  wiconBracketsPlus,
  wiconBuilding02,
  wiconBuilding05,
  wiconBuilding07,
  wiconCalendar,
  wiconCamera01,
  wiconCancelError,
  wiconCardSent,
  wiconCellEdit,
  wiconChartBreakoutCircle,
  wiconCheck,
  wiconCheckCircle,
  wiconCheckCircleBroken,
  wiconCheckDone01,
  wiconCheckSquare,
  wiconChecklist,
  wiconChevronDown,
  wiconChevronLeft,
  wiconChevronLeftDouble,
  wiconChevronRight,
  wiconChevronRightDouble,
  wiconChevronSelectorVertical,
  wiconChevronUp,
  wiconCircle,
  wiconCircleNotch,
  wiconClipboard,
  wiconClock,
  wiconClockRewind,
  wiconCoinsClock,
  wiconCoinsHand,
  wiconCoinsStacked02,
  wiconCoinsSuccess,
  wiconCollapse01,
  wiconCommand,
  wiconCopy02,
  wiconCopy03,
  wiconCopy05,
  wiconCopyRow,
  wiconCornerDownLeft,
  wiconCornerUpLeft,
  wiconCreditCard01,
  wiconCreditCard02,
  wiconCreditCardCheck,
  wiconCreditCardDown,
  wiconCreditCardRefresh,
  wiconCrown,
  wiconCurrencyDollarCircle,
  wiconData,
  wiconDataflow02,
  wiconDataflow03,
  wiconDocumentDot,
  wiconDocumentError,
  wiconDocumentNew,
  wiconDocumentSend,
  wiconDocumentSendError,
  wiconDocumentSendNoFile,
  wiconDocumentSendWaiting,
  wiconDocumentSuccess,
  wiconDotsHorizontal,
  wiconDotsVertical,
  wiconDownload03,
  wiconDownload04,
  wiconEdit01,
  wiconEdit03,
  wiconErp,
  wiconErpError,
  wiconErpSend,
  wiconErpSuccess,
  wiconErpWaiting,
  wiconExclamation,
  wiconExclamationCircleTriangle,
  wiconExclamationCircleTriangleGray,
  wiconExpand01,
  wiconEye,
  wiconEyeCheck,
  wiconEyeError,
  wiconEyeFlash,
  wiconEyeOff,
  wiconEyePreview,
  wiconEyeSend,
  wiconEyeWaiting,
  wiconFeather,
  wiconFile01,
  wiconFile02,
  wiconFile04,
  wiconFile05,
  wiconFile06,
  wiconFileCheck02,
  wiconFileIncome02,
  wiconFileMinus03,
  wiconFileOutcome02,
  wiconFilePdf,
  wiconFilePlus01,
  wiconFiles,
  wiconFilterFunnel01,
  wiconFlexAlignLeft,
  wiconFolder,
  wiconGrid01,
  wiconHash02,
  wiconHelpCircle,
  wiconHome05,
  wiconImage01,
  wiconInfoCircle,
  wiconLayoutAlt02,
  wiconLayoutGrid02,
  wiconLayoutLeft,
  wiconLayoutTop,
  wiconLink02,
  wiconLinkOff,
  wiconListAlt,
  wiconLoading01,
  wiconLock01,
  wiconLock03,
  wiconLock04,
  wiconLockUnlocked03,
  wiconLogOut01,
  wiconLogOut04,
  wiconMail01,
  wiconMail02,
  wiconMaximize01,
  wiconMaximize02,
  wiconMenu01,
  wiconMenu04,
  wiconMerge,
  wiconMessageTextCircle01,
  wiconMinimize01,
  wiconMinimize02,
  wiconMinus,
  wiconMinusCircle,
  wiconMoon01,
  wiconMoon02,
  wiconMove,
  wiconOcr,
  wiconPackageArrowRight,
  wiconPackageCheck,
  wiconPackageWait,
  wiconPackageX,
  wiconPaperPlaneCheck,
  wiconPaperclip,
  wiconPause,
  wiconPhone,
  wiconPhone01,
  wiconPieChart01,
  wiconPin02,
  wiconPipedrive,
  wiconPlayCircle,
  wiconPlus,
  wiconPower01,
  wiconPrinter,
  wiconPuzzlePiece01,
  wiconStars01,
  wiconQrCode02,
  wiconRoute,
  wiconReceipt,
  wiconReceiptCheck,
  wiconRefreshCcw01,
  wiconRefreshCw01,
  wiconRefreshCw02,
  wiconRefreshCw05,
  wiconRossum,
  wiconRows03,
  wiconSafe,
  wiconSave01,
  wiconSearchLg,
  wiconSearchMd,
  wiconSend01,
  wiconServer02,
  wiconSettings01,
  wiconSettings02,
  wiconSettings04,
  wiconShare03,
  wiconShare04,
  wiconShield01,
  wiconShield02,
  wiconShieldTick,
  wiconShoppingBag03,
  wiconShoppingCart01,
  wiconShuffle02,
  wiconSignatureFeather,
  wiconSignaturePen,
  wiconSigni,
  wiconSigniTransparent,
  wiconSlashCircle01,
  wiconSliders01,
  wiconStamp,
  wiconStar01,
  wiconStatusDonut,
  wiconStatusDot,
  wiconStatuspage,
  wiconSun,
  wiconSwitchHorizontal01,
  wiconTag03,
  wiconTagsPlus,
  wiconTextInput,
  wiconTrash01,
  wiconTrash04,
  wiconTrashUndo,
  wiconType01,
  wiconUpload01,
  wiconUpload03,
  wiconUploadCloud01,
  wiconUser01,
  wiconUserCircle,
  wiconUserPlus01,
  wiconUserPlus02,
  wiconUserShield,
  wiconUserX01,
  wiconUsers01,
  wiconUsersClass,
  wiconWflow,
  wiconWifiOff,
  wiconXCircle,
  wiconXClose,
  wiconPlusCircle,
  wiconMonitor01,
  wiconTarget04,
  wiconInbox01,
  wiconSend03,
  wiconArchive,
  wiconArrowCircleRight,
  wiconFileCheck03,
  wiconFileX03,
  wiconDotsHorizontal02,
} from 'wflow-icons';

export const ICONS: WIcon[] = [
  // New icons
  wiconChevronUp,
  wiconChevronDown,
  wiconChevronRight,
  wiconChevronLeft,
  wiconChevronLeftDouble,
  wiconChevronRightDouble,

  wiconArrowNarrowRight,
  wiconArrowNarrowLeft,
  wiconArrowNarrowDown,
  wiconArrowNarrowUp,
  wiconArrowNarrowDownRight,
  wiconArrowNarrowUpRight,
  wiconArrowLeft,

  wiconCornerUpLeft,
  wiconCornerDownLeft,

  wiconLogOut01,

  wiconRefreshCcw01,
  wiconRefreshCw01,
  wiconRefreshCw02,
  wiconShuffle02,

  wiconMaximize02,
  wiconMinimize02,

  wiconLock01,
  wiconLock03,
  wiconLock04,
  wiconLockUnlocked03,

  wiconCommand,
  wiconHash02,
  wiconPower01,
  wiconQrCode02,
  wiconRoute,

  wiconDownload03,
  wiconDownload04,
  wiconUpload01,
  wiconUpload03,
  wiconUploadCloud01,

  wiconAtSign,
  wiconMail01,
  wiconPrinter,

  wiconAlertCircle,
  wiconHelpCircle,
  wiconAlertTriangle,
  wiconInfoCircle,
  wiconPlayCircle,

  wiconClock,
  wiconClockRewind,
  wiconMenu01,
  wiconMenu04,
  wiconSliders01,
  wiconStar01,
  wiconDotsHorizontal,
  wiconDotsHorizontal02,
  wiconDotsVertical,
  wiconSearchMd,
  wiconSearchLg,
  wiconSettings01,
  wiconSettings02,
  wiconFilterFunnel01,
  wiconType01,

  wiconEdit01,
  wiconEdit03,
  wiconCopy02,
  wiconCopy03,
  wiconCopy05,
  wiconSave01,

  wiconLink02,
  wiconImage01,
  wiconShare03,
  wiconShare04,

  wiconCheckSquare,

  wiconMinus,
  wiconPlus,
  wiconXClose,
  wiconCheck,

  wiconTrash01,
  wiconTrash04,
  wiconEye,
  wiconEyeOff,

  wiconSend01,
  wiconBookClosed,
  wiconBookOpen01,

  wiconCoinsStacked02,

  wiconUser01,
  wiconUserPlus01,
  wiconUserPlus02,
  wiconUsers01,
  wiconUserX01,
  wiconUserCircle,

  wiconCreditCard01,
  wiconCreditCardCheck,
  wiconMessageTextCircle01,
  wiconCreditCardDown,

  wiconTag03,

  wiconRows03,

  wiconPhone,
  wiconPhone01,

  wiconPackageCheck,
  wiconPackageX,
  wiconClipboard,
  wiconMoon01,
  wiconMoon02,
  wiconSun,
  wiconLayoutTop,

  wiconXCircle,
  wiconLogOut04,
  wiconMinusCircle,
  wiconCheckCircle,
  wiconCheckCircleBroken,

  wiconShield01,
  wiconShield02,
  wiconBell01,

  wiconBracketsPlus,
  wiconBuilding05,
  wiconShieldTick,
  wiconMail02,
  wiconData,
  wiconDataflow03,
  wiconAnnouncement02,
  wiconServer02,
  wiconBuilding07,
  wiconLayoutAlt02,
  wiconLayoutLeft,
  wiconFlexAlignLeft,
  wiconDataflow02,
  wiconGrid01,
  wiconCheckDone01,
  wiconPieChart01,
  wiconLayoutGrid02,

  // Old icons
  wiconListAlt,
  wiconPackageWait,
  wiconDocumentError,
  wiconDocumentNew,
  wiconDocumentSend,
  wiconDocumentSendError,
  wiconDocumentSendWaiting,
  wiconDocumentSendNoFile,
  wiconDocumentSuccess,
  wiconCancelError,
  wiconStatuspage,
  wiconRossum,
  wiconStatusDot,
  wiconStatusDonut,
  wiconSigni,
  wiconSigniTransparent,
  wiconCellEdit,
  wiconBuilding02,
  wiconPin02,
  wiconWifiOff,
  wiconFileIncome02,
  wiconFileOutcome02,
  wiconReceipt,
  wiconEdit01,
  wiconSafe,
  wiconShoppingCart01,
  wiconFeather,
  wiconChevronSelectorVertical,

  wiconFile01,
  wiconFile02,
  wiconFile04,
  wiconFile05,
  wiconFile06,
  wiconFolder,
  wiconHome05,

  // Not replaced yet
  wiconDocumentDot,
  wiconPipedrive,
  wiconFilePdf,
  wiconFiles,
  wiconExclamationCircleTriangle,
  wiconExclamationCircleTriangleGray,
  wiconOcr,
  wiconErp,
  wiconErpError,
  wiconErpSend,
  wiconErpWaiting,
  wiconErpSuccess,
  wiconMerge,
  wiconMove,
  wiconCopyRow,
  wiconSignaturePen,
  wiconSignatureFeather,
  wiconExclamation,
  wiconPause,
  wiconTrashUndo,
  wiconStamp,
  wiconEyeFlash,
  wiconEyeError,
  wiconEyeCheck,
  wiconEyeWaiting,
  wiconEyeSend,
  wiconEyePreview,
  wiconCalendar,
  wiconPaperPlaneCheck,
  wiconCoinsClock,
  wiconCoinsSuccess,
  wiconUserShield,
  wiconUsersClass,
  wiconCardSent,
  wiconTagsPlus,
  wiconCrown,
  wiconCurrencyDollarCircle,
  wiconPackageArrowRight,
  wiconChecklist,
  wiconApprovePath,
  wiconApprovePathRemove,
  wiconApprovePathSetting,
  wiconApprovePathStepBack,
  wiconApproveBell,
  wiconCircle,
  wiconCircleNotch,
  wiconLinkOff,
  wiconMaximize01,
  wiconMinimize01,
  wiconPuzzlePiece01,
  wiconStars01,
  wiconFileCheck02,
  wiconFile05,
  wiconFile06,
  wiconFilePlus01,
  wiconTextInput,
  wiconSettings04,
  wiconPaperclip,
  wiconCoinsHand,
  wiconCreditCard02,
  wiconBank,
  wiconSlashCircle01,
  wiconRefreshCw05,
  wiconReceiptCheck,
  wiconShoppingBag03,
  wiconSwitchHorizontal01,
  wiconWflow,
  wiconCurrencyDollarCircle,
  wiconBookmark,
  wiconCreditCardRefresh,
  wiconBarChart10,
  wiconChartBreakoutCircle,
  wiconAttachment02,
  wiconCollapse01,
  wiconExpand01,
  wiconCamera01,
  wiconPlusCircle,
  wiconMonitor01,
  wiconTarget04,
  wiconInbox01,
  wiconSend03,
  wiconArchive,
  wiconArrowCircleRight,
  wiconFileCheck03,
  wiconFileMinus03,
  wiconFileX03,
  wiconLoading01,
  wiconVector,
];
